import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../utils/api";
import { motion } from "framer-motion";
import { FaBalanceScale } from "react-icons/fa";

/* =========================
  Helpers
========================= */
const normalizeAnswer = (value) =>
  String(value || "").trim().replace(/\s+/g, " ");

export default function SetupSecurityQuestion() {
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null); // { type, text }

  const navigate = useNavigate();

  const saveAnswer = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setMessage({ type: "error", text: "🚫 لازم تسجل دخول الأول" });
      return;
    }

    const clean = normalizeAnswer(answer);
    if (!clean || clean.length < 2) {
      setMessage({ type: "warning", text: "⚠️ من فضلك اكتب إجابة صحيحة" });
      return;
    }

    try {
      setLoading(true);
      setMessage(null);

      await api.post(
        "/auth/set-security-answer",
        { answer: clean },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setMessage({ type: "success", text: "✅ تم حفظ إجابة سؤال الأمان بنجاح" });

      setTimeout(() => {
        navigate("/dashboard");
      }, 650);
    } catch (err) {
      console.error("❌ set-security-answer error:", err);
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "⚠️ حصل خطأ أثناء حفظ الإجابة";

      setMessage({ type: "error", text: msg });
    } finally {
      setLoading(false);
    }
  };

  const onEnter = (e) => {
    if (e.key === "Enter") saveAnswer();
  };

  return (
    <div
      className="flex items-center justify-center h-screen w-full bg-cover bg-center relative px-4"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1600334129128-685c5a7b4f01?auto=format&fit=crop&w=1500&q=80')",
      }}
    >
      <div className="absolute inset-0 bg-black/80" />

      <motion.div
        initial={{ opacity: 0, y: -35 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative z-10 bg-gray-900/95 border border-yellow-500 p-8 md:p-10 rounded-2xl shadow-2xl w-full max-w-lg text-center"
      >
        <FaBalanceScale className="text-yellow-400 text-5xl mx-auto mb-4" />
        <h2 className="text-3xl font-bold text-yellow-400 mb-2">إعداد سؤال الأمان</h2>

        <p className="text-sm text-gray-400 mb-6">
          لازم تسجّل إجابة سؤال الأمان مرة واحدة عشان تقدر تسترجع كلمة المرور بعدين ⚖️
        </p>

        <div className="text-start">
          <label className="block text-xs text-gray-400 mb-1">🧩 سؤال الأمان</label>
          <div className="w-full p-3 mb-4 bg-gray-800 rounded border border-gray-700 text-white">
            اسم والد والدتك
          </div>

          <label className="block text-xs text-gray-400 mb-1">✍️ الإجابة</label>
          <input
            type="text"
            placeholder="اكتب الإجابة"
            className="w-full p-3 mb-6 bg-gray-800 rounded border border-gray-700 text-white focus:outline-none focus:border-yellow-400 placeholder-gray-400"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            onKeyDown={onEnter}
          />
        </div>

        <button
          onClick={saveAnswer}
          disabled={loading}
          className={`w-full py-3 font-bold rounded-lg shadow-md transition-all duration-300 ${
            loading
              ? "bg-gray-500 cursor-not-allowed text-gray-300"
              : "bg-yellow-500 hover:bg-yellow-400 text-black"
          }`}
        >
          {loading ? "⏳ جاري الحفظ..." : "✅ حفظ والمتابعة"}
        </button>

        <div className="mt-5 text-sm flex justify-center gap-6">
          <Link to="/dashboard" className="text-gray-400 hover:text-yellow-300 transition">
            تخطي والذهاب للوحة التحكم
          </Link>
        </div>

        {message && (
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35 }}
            className={`mt-6 p-3 rounded-lg text-sm font-semibold ${
              message.type === "success"
                ? "bg-green-600/30 text-green-300 border border-green-500"
                : message.type === "error"
                ? "bg-red-600/30 text-red-300 border border-red-500"
                : "bg-yellow-600/30 text-yellow-300 border border-yellow-500"
            }`}
          >
            {message.text}
          </motion.div>
        )}
      </motion.div>
    </div>
  );
}
